import axios from "axios";
import {BASE_URL} from "../../constants/API";

export async function getContactUsHeader() {
    return await axios.get(BASE_URL + '/contact-us-headers?populate=image');
}

export async function getContactUsSupport() {
    return await axios.get(BASE_URL + '/contact-us-supports?populate=contactImage&populate=chatImage&populate=whatsappImage&populate=telegramImage&populate=backgroundImage');
}